import { RootState } from 'redux/store'

export const sortingSelector = (state: RootState) =>
  state.sortingReducer.sortingData
